"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.13 350.48",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M544.55,391.24l-.2-51.32a6.87,6.87,0,0,0-5-6.59L498.2,321.7,443.48,245a6.85,6.85,0,0,0-5.59-2.88H410.77V209.34a7,7,0,0,0-7-7H213.09l-19.86,0a7,7,0,0,0-7,7V295.4a7,7,0,0,0,14,0V216.34H396.75v39.47h37.6l54.06,75.83a6.85,6.85,0,0,0,3.73,2.62l38.48,10.88,0,46.09v25.65a7,7,0,0,1-7,7H493.15s.06,7.23.06,7.51a29.4,29.4,0,0,1-58.8,0s0-.08,0-.13h0v-7.38h-136s.09,7.08.09,7.51a29.39,29.39,0,0,1-58.06,6.48,31.45,31.45,0,0,1-.58-3.77,27,27,0,0,1-.16-2.71v-7.31H203.44a143.09,143.09,0,0,1-22-2.08c-63.76-11.1-112.29-64.83-112.29-129.29,0-43.24,21.84-81.66,55.47-105.63A139.2,139.2,0,0,1,192.1,162q6.32-.6,12.78-.64h73.54a29.35,29.35,0,0,0,1.73,5.25,29.93,29.93,0,0,0,25.91,18c.51,0,1,.06,1.53.06l22.88-.06V174h15a6.88,6.88,0,0,0,0-13.75h-15v-11h15a6.88,6.88,0,0,0,0-13.75h-15V124.76H307.59a30,30,0,0,0-29,22.81H206.83l-1,0-1,0h-2.69a94.77,94.77,0,0,0-11.49.72c-75.85,7.36-135.27,69.32-135.27,144.43,0,58.29,35.79,108.63,87.26,131.71a153.75,153.75,0,0,0,56.77,13.31c1.39.06,2.78.08,4.17.1.5,0,1,0,1.49,0l.74,0,.74,0h19.22a43.78,43.78,0,0,0,86.61,0H420.51a43.77,43.77,0,0,0,86.6,0h16.47a21,21,0,0,0,21-21V391.24ZM292.61,148.58a16.22,16.22,0,0,1,12.51-9.88c.11,0,.23,0,.34,0,2-.1,11.26-.16,11.26-.16v32.37s-9.41-.07-11.32-.18l-.29,0a16.19,16.19,0,0,1-11.58-8,16,16,0,0,1-.92-14.1Z",
      transform: "translate(-55.43 -124.76)"
    })
  });
};

exports.default = Icon;